module.exports = __webpack_public_path__ + "static/media/selva-beat.aa81531c.jpg";